import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    Empty,
    Flex,
    Input,
    Spin,
    Space,
    Tooltip,
    Typography,
    Skeleton,
    message,
    Dropdown,
    Menu,
    Tag,
} from "antd";
import {
    SearchOutlined,
    PlusOutlined,
    ReloadOutlined,
    EditOutlined,
    DeleteOutlined,
    DownOutlined,
    LeftOutlined,
    RightOutlined,
    InboxOutlined,
    CloseCircleOutlined,
    CheckCircleOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import api from "../../../api";
import RejectionModal from "../Approval/RejectionModal";


const { Title, Text } = Typography;

const VendorDiscount = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [typeFilter, setTypeFilter] = useState("All");
    const [statusFilter, setStatusFilter] = useState("All");

    const [pageSize, setPageSize] = useState(6);
    const [currentPage, setCurrentPage] = useState(1);
    const [messageApi, contextHolder] = message.useMessage();
    const [openRejectionModal, setOpenRejectionModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [actionType, setActionType] = useState(""); // "approve" | "reject"
    const navigate = useNavigate();



    useEffect(() => {
        fetchMarketPlace();
    }, []);

    const fetchMarketPlace = async () => {
        try {
            setLoading(true);

            const payload = {
                "fld_user_id": "admin",
                "synceddatetime": "2025-05-29 10:08:00",
                "formcode": "201",
                "appversion": "1.0.0.0",
                "apikey": "kavin",
                "apptypeno": "3"
            }

            const res = await api.getVendorDiscount(payload);

            if (res?.data?.status === "1") {
                const mappedData = res.data.vendor_discount_data
                    .sort(
                        (a, b) =>
                            new Date(b.fld_created_date) -
                            new Date(a.fld_created_date)
                    )
                    .map((item) => ({
                        id: item.fld_slno,
                        rfId: item.fld_rf_id, // 🔥 IMPORTANT (for API)

                        name: item.fld_discount_name,
                        description: item.fld_discount_description,

                        code: item.fld_discount_code || item.fld_coupen_code,

                        type: item.fld_discount_type_name === "Percentage" ? "Percentage" : "Flat",

                        value: item.fld_discount_value?.toString().replace(/[^\d.]/g, ""),

                        minOrder: item.fld_minimum_order_value,
                        maxDiscount: item.maximum_discount,

                        startDate: item.fld_start_date,
                        endDate: item.fld_end_date,

                        status: item.fld_is_active === "1" ? "Active" : "Inactive",

                        fld_is_approval_rejection: item.fld_is_approval_rejection,

                        // 🔥 ADD THESE (for details page)
                        usageLimit: item.fld_total_usage_limit,
                        perUserLimit: item.fld_user_limit,
                        applyOn: item.fld_apply_discount_on,
                        userEligibility: item.fld_user_eligibility,
                        createdDate: item.fld_created_date,
                        email: item.fld_contact_email,
                        mobile: item.fld_contact_mobile,

                        // split $ into list-friendly text
                        howToRedeem: item.fld_how_to_redeem?.split("$").join(", "),
                        terms: item.fld_terms_condation?.split("$").join(", "),

                        vendorName: item.fld_vendor_name,
                        raw: item
                    }));

                setData(mappedData);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleConfirmAction = (reason) => {
        if (!selectedItem || !actionType) return;

        handleApproval(selectedItem, actionType, reason);

        setOpenRejectionModal(false);
        setSelectedItem(null);
        setActionType("");
    };


    const handleApproval = async (item, type, reason) => {
        try {
            setLoading(true);

            const payload = {
                fld_rf_id: item.rfId,
                fld_user_id: "admin",
                fld_is_approval_rejection: type === "approve" ? "1" : "2",
                fld_is_approval_rejection_name: type === "approve" ? "approved" : "rejected",
                fld_reason_for_rejection: reason ? reason : "",

                synceddatetime: "2025-05-29 10:08:00",
                formcode: "201",
                appversion: "1.0.0.0",
                apikey: "kavin",
                apptypeno: "3"
            };

            const res = await api.vendorApproveReject(payload);

            if (res?.data?.status === "1") {
                // ✅ update UI instantly
                messageApi.success(type === "approve" ? "Approved successfully" : "Rejected Successfully");
                setData((prev) =>
                    prev.map((d) =>
                        d.id === item.id
                            ? { ...d, fld_is_approval_rejection: type === "approve" ? "1" : "2" }
                            : d
                    )
                );
            }
        } catch (err) {
            console.error(err);
            messageApi.success(type === "approve" ? "Approved Failed" : "Rejection Failed");

        } finally {
            setLoading(false);
        }
    };

    // 🔍 Filters
    const filtered = data.filter((item) => {
        const matchesSearch = item.name
            .toLowerCase()
            .includes(searchTerm.toLowerCase());

        const matchesType =
            typeFilter === "All" || item.type === typeFilter;

        const matchesStatus =
            statusFilter === "All" ||
            (statusFilter === "Approved" &&
                item.fld_is_approval_rejection === "1") ||
            (statusFilter === "Rejected" &&
                item.fld_is_approval_rejection === "2") ||
            (statusFilter === "Pending" &&
                (item.fld_is_approval_rejection === "0" ||
                    !item.fld_is_approval_rejection));

        return matchesSearch && matchesType && matchesStatus;
    });
    // 📄 Pagination
    const startIndex = (currentPage - 1) * pageSize;
    const paginated = filtered.slice(startIndex, startIndex + pageSize);
    const totalPages = Math.ceil(filtered.length / pageSize);

    const pageMenu = (
        <Menu
            items={[6, 10, 20].map((num) => ({
                key: num,
                label: num,
                onClick: () => {
                    setPageSize(num);
                    setCurrentPage(1);
                },
            }))}
        />
    );

    return (
        <Spin spinning={loading}>
            {contextHolder}

            {openRejectionModal && (
                <RejectionModal
                    title={actionType === "approve" ? "Approve Discount" : "Reject Discount"}
                    content={
                        actionType === "approve"
                            ? "Are you sure you want to approve this discount?"
                            : "Are you sure you want to reject this discount?"
                    }
                    open={openRejectionModal}
                    buttonName={actionType === "approve" ? "Approve" : "Reject"}
                    onClose={() => setOpenRejectionModal(false)}
                    onSubmit={handleConfirmAction}
                />
            )}
            <div className="review-page">
                {/* Header */}
                <Flex className="review-header" justify="space-between" align="center" style={{ marginBottom: 16 }}>
                    <Input
                        className="review-search"
                        prefix={<SearchOutlined />}
                        placeholder="Search discount..."
                        style={{ width: 300 }}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                    />

                    {/* <Button type="primary" icon={<PlusOutlined />} style={{ background: "#0072b1" }}>
                        Create Discount
                    </Button> */}
                </Flex>

                {/* Title */}
                <div className="review-container">
                    <div className="review-heading">
                        <Title level={4} style={{ margin: 0 }}>Vendor Discounts</Title>
                        <Text type="secondary">Manage promotional offers and coupons</Text>
                    </div>

                    {/* Filters */}
                    <div className="review-filters">
                        <div className="filter-buttons">
                            <Dropdown
                                overlay={
                                    <Menu
                                        items={[
                                            { key: "All", label: "All", onClick: () => setTypeFilter("All") },
                                            { key: "Percentage", label: "Percentage", onClick: () => setTypeFilter("Percentage") },
                                            { key: "Flat", label: "Flat", onClick: () => setTypeFilter("Flat") },
                                        ]}
                                    />
                                }
                            >
                                <Button>
                                    {typeFilter} <DownOutlined />
                                </Button>
                            </Dropdown>
                            <Dropdown
                                overlay={
                                    <Menu
                                        items={[
                                            {
                                                key: "All",
                                                label: "All Status",
                                                onClick: () => setStatusFilter("All"),
                                            },
                                            {
                                                key: "Approved",
                                                label: "Approved",
                                                onClick: () => setStatusFilter("Approved"),
                                            },
                                            {
                                                key: "Rejected",
                                                label: "Rejected",
                                                onClick: () => setStatusFilter("Rejected"),
                                            },
                                            {
                                                key: "Pending",
                                                label: "Pending",
                                                onClick: () => setStatusFilter("Pending"),
                                            },
                                        ]}
                                    />
                                }
                            >
                                <Button>
                                    Status: {statusFilter} <DownOutlined />
                                </Button>
                            </Dropdown>

                            <Button
                                icon={<ReloadOutlined />}
                                onClick={() => {
                                    setTypeFilter("All");
                                    setStatusFilter("All");
                                    setSearchTerm("");
                                    setCurrentPage(1);
                                }}
                            >
                                Reset
                            </Button>
                        </div>
                    </div>

                    {/* Cards */}
                    <div style={{ display: "grid", gap: 16, marginTop: 16 }}>
                        {loading ? (
                            Array.from({ length: pageSize }).map((_, index) => (
                                <Card key={index}>
                                    <Flex justify="space-between" align="center">
                                        {/* Left Side */}
                                        <div style={{ flex: 1 }}>
                                            <Flex align="center" gap={8}>
                                                <Skeleton.Input
                                                    active
                                                    style={{ width: 180, height: 24 }}
                                                />
                                                <Skeleton.Button
                                                    active
                                                    size="small"
                                                    style={{ width: 80 }}
                                                />
                                                <Skeleton.Button
                                                    active
                                                    size="small"
                                                    style={{ width: 80 }}
                                                />
                                            </Flex>

                                            <div style={{ marginTop: 12 }}>
                                                <Skeleton
                                                    active
                                                    paragraph={{ rows: 2 }}
                                                    title={false}
                                                />
                                            </div>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: 8,
                                                    marginTop: 12,
                                                    flexWrap: "wrap",
                                                }}
                                            >
                                                <Skeleton.Button active size="small" />
                                                <Skeleton.Button active size="small" />
                                                <Skeleton.Button active size="small" />
                                                <Skeleton.Button active size="small" />
                                            </div>
                                        </div>

                                        {/* Right Side Buttons */}
                                        <Space>
                                            <Skeleton.Button active />
                                            <Skeleton.Button active />
                                        </Space>
                                    </Flex>
                                </Card>
                            ))
                        ) :
                            paginated.length === 0 ? (
                                <Card>
                                    <Empty description="No discounts found" image={<InboxOutlined style={{ fontSize: 40 }} />} />
                                </Card>
                            ) : (
                                paginated.map((item) => (
                                    <Card key={item.id} hoverable
                                        onClick={() =>
                                            navigate(`vendordiscount/${item.rfId}`, {
                                                state: { vendorData: item },
                                            })
                                        }
                                    >
                                        <Flex justify="space-between" align="center">
                                            {/* Left */}
                                            <div style={{ maxWidth: 500 }}>
                                                <Flex align="center" gap={8}>
                                                    <Text strong>{item.name}</Text>
                                                    <Tag color={item.type === "Percentage" ? "blue" : "purple"}>
                                                        {item.type === "Percentage" ? `${item.value}%` : `₹ ${item.value}`}
                                                    </Tag>
                                                    <Tag color={item.status === "Active" ? "green" : "red"}>
                                                        {item.status}
                                                    </Tag>
                                                </Flex>

                                                {/* Description */}
                                                <div style={{ color: "#888", marginTop: 4 }}>
                                                    <div
                                                        style={{
                                                            display: "-webkit-box",
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden",
                                                        }}
                                                    >
                                                        {item.description}
                                                    </div>
                                                </div>

                                                {/* Meta */}
                                                <div style={{ marginTop: 6, display: "flex", gap: 10, flexWrap: "wrap" }}>
                                                    <Tag>Code: {item.code}</Tag>
                                                    <Tag>Min Order: ₹ {item.minOrder}</Tag>
                                                    {item.maxDiscount && <Tag>Max: ₹ {item.maxDiscount}</Tag>}
                                                    <Tag>
                                                        {dayjs(item.startDate).format("DD MMM")} - {dayjs(item.endDate).format("DD MMM")}
                                                    </Tag>
                                                </div>
                                            </div>

                                            {/* Right */}
                                            <Space size="middle" className="approve-buttons">
                                                {/* ✅ Approved */}
                                                {item.fld_is_approval_rejection === "1" && (
                                                    <>
                                                        <Tag color="green">Approved</Tag>

                                                        <Tooltip title="Reject this item">
                                                            <Button
                                                                type="primary"
                                                                icon={<CloseCircleOutlined />}
                                                                style={{
                                                                    borderRadius: 8,
                                                                    fontWeight: 500,
                                                                    background: "linear-gradient(135deg, #FF7A7A, #FF4D4F)",
                                                                    padding: "0 16px",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setSelectedItem(item);
                                                                    setActionType("reject");
                                                                    setOpenRejectionModal(true);
                                                                }}
                                                            >
                                                                Reject
                                                            </Button>
                                                        </Tooltip>
                                                    </>
                                                )}

                                                {/* ❌ Rejected */}
                                                {item.fld_is_approval_rejection === "2" && (
                                                    <>
                                                        <Tag color="red">Rejected</Tag>

                                                        <Tooltip title="Approve this item">
                                                            <Button
                                                                type="primary"
                                                                icon={<CheckCircleOutlined />}
                                                                style={{
                                                                    background: "linear-gradient(135deg, #73E2A7, #52C41A)",
                                                                    borderRadius: 8,
                                                                    fontWeight: 500,
                                                                    padding: "0 16px",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setSelectedItem(item);
                                                                    setActionType("approve");
                                                                    setOpenRejectionModal(true);
                                                                }}
                                                            >
                                                                Approve
                                                            </Button>
                                                        </Tooltip>
                                                    </>
                                                )}

                                                {/* ⏳ Pending */}
                                                {(item.fld_is_approval_rejection === "0" ||
                                                    !item.fld_is_approval_rejection) && (
                                                        <>
                                                            <Tag color="orange">Pending</Tag>

                                                            <Tooltip title="Approve this item">
                                                                <Button
                                                                    type="primary"
                                                                    icon={<CheckCircleOutlined />}
                                                                    style={{
                                                                        background: "linear-gradient(135deg, #73E2A7, #52C41A)",
                                                                        borderRadius: 8,
                                                                        fontWeight: 500,
                                                                        padding: "0 16px",
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setSelectedItem(item);
                                                                        setActionType("approve");
                                                                        setOpenRejectionModal(true);
                                                                    }}
                                                                >
                                                                    Approve
                                                                </Button>
                                                            </Tooltip>

                                                            <Tooltip title="Reject this item">
                                                                <Button
                                                                    type="primary"
                                                                    icon={<CloseCircleOutlined />}
                                                                    style={{
                                                                        borderRadius: 8,
                                                                        fontWeight: 500,
                                                                        background: "linear-gradient(135deg, #FF7A7A, #FF4D4F)",
                                                                        padding: "0 16px",
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setSelectedItem(item);
                                                                        setActionType("reject");
                                                                        setOpenRejectionModal(true);
                                                                    }}
                                                                >
                                                                    Reject
                                                                </Button>
                                                            </Tooltip>
                                                        </>
                                                    )}
                                            </Space>
                                        </Flex>
                                    </Card>
                                ))
                            )}
                    </div>

                    {/* Pagination */}
                    <Flex justify="center" align="center" gap={10} style={{ marginTop: 20 }}>
                        <Button
                            icon={<LeftOutlined />}
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((p) => p - 1)}
                        />

                        <span>Page {currentPage} of {totalPages || 1}</span>

                        <Button
                            icon={<RightOutlined />}
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((p) => p + 1)}
                        />

                        <Dropdown overlay={pageMenu}>
                            <Button>
                                {pageSize} / page <DownOutlined />
                            </Button>
                        </Dropdown>
                    </Flex>
                </div>
            </div>
        </Spin >
    );
};

export default VendorDiscount;
